import SJCL from 'sjcl'
window.sjcl = SJCL
import 'sjcl/core/codecBytes'
import 'sjcl/core/hkdf'

export default SJCL
